import React, { lazy } from 'react';
import { getTypeformUrl } from '../utils/cookies';
export const HeroSection = () => {
  const handleScheduleTour = e => {
    e.preventDefault();
    // Redirect to Typeform with fbp parameter if available
    window.location.href = getTypeformUrl();
  };
  return <section className="relative min-h-screen flex items-center bg-white" data-id="element-170">
      {/* Content */}
      <div className="container mx-auto px-4 md:px-8 relative z-10 pt-8 pb-16 md:pb-24 flex flex-col items-center" data-id="element-171">
        <div className="max-w-3xl mx-auto text-center" data-id="element-172">
          <div className="text-black py-2 px-4 rounded-md mb-4 md:mb-10 mt-4 md:mt-8 inline-flex items-center gap-2 bg-gray-100 border border-gray-200 shadow-lg" data-id="element-173">
            <span className="font-bold text-base md:text-base" data-id="element-174">New</span>
            <span className="text-accent text-lg md:text-xl" data-id="element-175">★</span>
            <span className="text-sm md:text-base" data-id="element-176">
              For Indian American Investors:
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-black leading-tight mb-8 md:mb-10" data-id="element-177">
            Dubai's Booming Property Market Is Bringing Investors 15-20% Capital
            Gains Annually
          </h1>
          <p className="text-black mb-8 md:mb-10 text-base md:text-xl font-medium" data-id="element-178">
            Watch The Video Below To Discover How You Can Invest In The Fastest
            Growing Real Estate Market In The World
          </p>
          {/* Video Embed */}
          <div className="mb-8 md:mb-10 w-full max-w-2xl mx-auto" data-id="element-179">
            <div style={{
            position: 'relative',
            paddingTop: '56.25%'
          }} data-id="element-180">
              <iframe src="https://iframe.mediadelivery.net/embed/478913/fd1a8808-bcaf-47a9-8d5f-ff56fe812c5d?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
              border: 0,
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%'
            }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-181"></iframe>
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-black mb-2" data-id="element-182">
            Step 2 Of 3: Complete Your Application
          </h2>
          <p className="text-gray-600 mb-6 md:mb-8" data-id="element-183">
            (NOTE: Every application is reviewed by one of our team members)
          </p>
          <a href="#" onClick={handleScheduleTour} className="btn-primary text-white px-12 py-6 md:px-18 md:py-9 rounded-md font-bold text-2xl md:text-3xl inline-block shadow-2xl hover:shadow-2xl animate-pulse-slow transform hover:scale-105 transition-all duration-300 border-2 border-[#2f4930] w-full md:w-auto text-center mb-6 md:mb-12" data-id="element-184">
            Schedule Your Exclusive Digital Tour
          </a>
        </div>
      </div>
    </section>;
};